// extracted by mini-css-extract-plugin
export default {"chainInfoWrapper":"EllipsisButtons_chainInfoWrapper__79Q5z","ellipsisIcon":"EllipsisButtons_ellipsisIcon__gAgU6","activeIcon":"EllipsisButtons_activeIcon__bdY3U"};